export default {
   parseDate: function (calendarConfig, dateText) {
      let dateObj = undefined;

      let splitToken = "/";
      if(calendarConfig.dateFormat.includes("-"))
      {
         splitToken = "-"
      }
      var parts = (dateText || '').split(splitToken);
      if(parts.length === 3)
      {
         try
         {
            var year = parts[calendarConfig.yearPosition - 1];
            var month = parts[calendarConfig.monthPosition - 1] - 1;
            var day = parts[calendarConfig.dayPosition - 1];

            dateObj = new Date(year, month, day);
         }
         catch(e)
         {
           // Ignore.
         }
      }
      console.log("ParseDate", calendarConfig, dateText, dateObj);
      return dateObj;
   },

   addDays: function(dateObj, nbOfDays) {
      dateObj.setDate(dateObj.getDate() + nbOfDays);
      console.log("addDays", dateObj, nbOfDays);
      return dateObj;
   },

   formatDate: function (calendarConfig, dateObj) {
      var parts = [];
      parts[calendarConfig.yearPosition - 1] = dateObj.getFullYear();
      parts[calendarConfig.monthPosition - 1] = dateObj.getMonth() + 1;
      parts[calendarConfig.dayPosition - 1] = dateObj.getDate();
      let dateText = parts[0] + "/" + parts[1] + "/" + parts[2];
      console.log("FormatDate", calendarConfig, dateObj, dateText);
      return dateText;
   },

   getNbHours: function(millis, precision) {
      return parseFloat(millis / 3600000).toFixed(precision)
   },

   millisToHMS: function (millis) {
      // 1- Convert to seconds:
      let seconds = parseInt( millis / 1000);
      // 2- Extract hours:
      const hours = parseInt(seconds / 3600); // 3,600 seconds in 1 hour
      seconds = seconds % 3600; // seconds remaining after extracting hours
      // 3- Extract minutes:
      const minutes = parseInt(seconds / 60); // 60 seconds in 1 minute
      // 4- Keep only seconds not extracted to minutes:
      seconds = seconds % 60;
      return hours + "h " + minutes + "m " + seconds + "s";
   }
}